import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import ResearchImg from '../Assests/16.png';

const glass = css`
  backdrop-filter: blur(26px) saturate(175%) brightness(1.03);
  -webkit-backdrop-filter: blur(26px) saturate(175%) brightness(1.03);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.04)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.55), rgba(255,255,255,0.18), rgba(139,29,29,0.16)) border-box;

  box-shadow:
    0 18px 55px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.35);
`;

const glassSoft = css`
  backdrop-filter: blur(18px) saturate(165%) brightness(1.02);
  -webkit-backdrop-filter: blur(18px) saturate(165%) brightness(1.02);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.45), rgba(255,255,255,0.16), rgba(139,29,29,0.14)) border-box;

  box-shadow:
    0 14px 45px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.28);
`;

const ResearchSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen((v) => !v);

  return (
    <Section id="research">
      <Shell>
        <Header>
          <Title>Research</Title>
          <Subtitle>Peer-reviewed output and project documentation.</Subtitle>
        </Header>

        <Card>
          <Grid>
            <Media>
              <MediaFrame>
                <img src={ResearchImg} alt="Research illustration" />
              </MediaFrame>
              <MediaNote>Updated materials and citations available via the links.</MediaNote>
            </Media>

            <Body>
              <ListTitle>Featured Publication</ListTitle>
              <List>
                <li>
                  <a
                    href="https://www.researchgate.net/publication/381189686_eBaybayMo_An_E-Learning_Mobile_Application_Tool_for_Transliterating_Baybayin_Characters_to_Latin_Letters_using_k-NN_Algorithm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    eBaybayMo: An E-Learning Mobile Application Tool for Transliterating Baybayin Characters to Latin Letters using k-NN Algorithm
                  </a>
                </li>
              </List>

              <Actions>
                <PrimaryButton onClick={toggleModal}>Explore</PrimaryButton>
              </Actions>
            </Body>
          </Grid>
        </Card>
      </Shell>

      {isModalOpen && (
        <ModalOverlay onClick={toggleModal}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalHead>
              <ModalTitle>Explore</ModalTitle>
              <CloseButton onClick={toggleModal} aria-label="Close modal">
                ×
              </CloseButton>
            </ModalHead>

            <ModalBody>
              <p>
                You can add more research links here (DOIs, PDF, conference pages), or embed a short abstract, metrics,
                and citations.
              </p>

              <ModalLinks>
                <a
                  href="https://www.researchgate.net/publication/381189686_eBaybayMo_An_E-Learning_Mobile_Application_Tool_for_Transliterating_Baybayin_Characters_to_Latin_Letters_using_k-NN_Algorithm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open on ResearchGate
                </a>
              </ModalLinks>
            </ModalBody>
          </Modal>
        </ModalOverlay>
      )}
    </Section>
  );
};

export default ResearchSection;

/* ---------- Styles ---------- */

const Section = styled.section`
  min-height: 100vh;
  padding: 5.5rem 1rem 4rem;
  position: relative;
  background: transparent;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 720px;
    height: 720px;
    left: -320px;
    top: 120px;
    background: radial-gradient(circle at 35% 35%, rgba(139,29,29,0.18), transparent 62%);
    filter: blur(70px);
    opacity: 0.9;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    width: 760px;
    height: 760px;
    right: -340px;
    bottom: -340px;
    background: radial-gradient(circle at 40% 40%, rgba(246,201,69,0.16), transparent 62%);
    filter: blur(80px);
    opacity: 0.9;
    pointer-events: none;
  }
`;

const Shell = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 1.6rem;
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 1000;
  font-size: clamp(3rem, 3.2vw, 2.6rem);
  color: #8b1d1d;
  letter-spacing: -0.02em;
`;

const Subtitle = styled.p`
  margin: 0.55rem auto 0;
  max-width: 820px;
  font-family: 'Poppins', sans-serif;
  color: rgba(32, 21, 21, 0.70);
  font-size: 1.75rem;
`;

const Card = styled.div`
  ${glass}
  border-radius: 24px;
  padding: 10rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 2rem;
  align-items: center;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Media = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.30rem;
  align-items: center;
`;

const MediaFrame = styled.div`
  ${glassSoft}
  border-radius: 18px;
  padding: 1rem;
  width: 100%;
  max-width: 420px;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 14px;
  }
`;

const MediaNote = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: rgba(32, 21, 21, 0.68);
`;

const Body = styled.div`
  text-align: left;

  @media (max-width: 980px) {
    text-align: center;
  }
`;

const ListTitle = styled.h3`
  margin: 0 0 0.65rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  font-size: 2rem;
  color: rgba(32, 21, 21, 0.86);
`;

const List = styled.ul`
  margin: 0;
  padding-left: 1.2rem;
  font-family: 'Poppins', sans-serif;
  line-height: 1.6;
  color: rgba(32, 21, 21, 0.78);

  a {
    color: rgba(139, 29, 29, 0.95);
    font-weight: 800;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (max-width: 980px) {
    padding-left: 1.1rem;
    text-align: left;
    display: inline-block;
  }
`;

const Actions = styled.div`
  margin-top: 1.1rem;
  display: flex;
  gap: 0.8rem;

  @media (max-width: 980px) {
    justify-content: center;
  }
`;

const PrimaryButton = styled.button`
  ${glassSoft}
  border-radius: 999px;
  padding: 0.85rem 1.35rem;
  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(246,201,69,0.52), rgba(246,201,69,0.18)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.75), rgba(139,29,29,0.22)) border-box;

  color: rgba(32, 21, 21, 0.92);
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  cursor: pointer;

  transition: transform 0.16s ease, filter 0.16s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.03);
  }

  &:active {
    transform: translateY(0px) scale(0.99);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.45);
  display: grid;
  place-items: center;
  z-index: 9999;
  padding: 1rem;
`;

const Modal = styled.div`
  ${glass}
  width: min(560px, 96vw);
  border-radius: 22px;
  padding: 1.2rem 1.2rem 1.25rem;
  color: rgba(32, 21, 21, 0.90);
`;

const ModalHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 950;
  color: #8b1d1d;
`;

const CloseButton = styled.button`
  ${glassSoft}
  border-radius: 14px;
  border: 1px solid transparent;
  width: 42px;
  height: 42px;
  font-size: 1.35rem;
  font-weight: 900;
  cursor: pointer;
  color: rgba(32, 21, 21, 0.85);

  &:hover {
    filter: brightness(1.04);
  }
`;

const ModalBody = styled.div`
  font-family: 'Poppins', sans-serif;
  line-height: 1.6;
  color: rgba(32, 21, 21, 0.80);
  p { margin: 0 0 0.9rem; }
`;

const ModalLinks = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;

  a {
    ${glassSoft}
    border-radius: 999px;
    padding: 0.75rem 1.1rem;
    text-decoration: none;
    color: rgba(139, 29, 29, 0.95);
    font-weight: 900;
  }

  a:hover {
    filter: brightness(1.03);
  }
`;
